// extracted by mini-css-extract-plugin
module.exports = {"wrap":"e_z7","pin":"e_A7","tip":"e_B7","wrapOpen":"e_C7"};